import { LANG_NAMES, LANG_SHORT } from "@shared/i18n";
import { lang, LANGS, setLang, t } from "@/i18n";
import { cx } from "./ui";

/** Переключатель языка: LT · RU · EN. Смена языка перезагружает страницу. */
export function LangSwitch({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <div role="group" aria-label={t("Язык")} className={cx("inline-flex rounded-xl bg-black/5 p-0.5 dark:bg-white/10", className)}>
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          lang={l}
          title={LANG_NAMES[l]}
          aria-pressed={l === lang}
          onClick={() => void setLang(l)}
          className={cx(
            "rounded-[10px] px-2.5 py-1 text-[12px] font-bold transition",
            l === lang ? "bg-[var(--surface)] text-[var(--fg)] shadow-sm" : "text-muted hover:text-[var(--fg)]",
          )}
        >
          {compact ? LANG_SHORT[l] : LANG_NAMES[l]}
        </button>
      ))}
    </div>
  );
}
